import React from "react"
import { CLIENT_REPORT_EMPTY_CHART_MESSAGE } from "../../../consts/charts.consts"
import PieChartCompound from "../../../components/compounds/graphics/PieChart.compound"
import SquareRoundedColorListLegend from "../../../components/compounds/graphics/components/SquareRoundedColorListLegend"

const GeneralSprintPointProgressChart = ({
  data,
  loading = false,
  className = "",
  chartContainerConfig = {
    shadow: false,
    className: "w-full mx-auto p-0 sprint-progress-chart flex-1",
  },
  responsiveContainerConfig = {
    minHeight: "220px",
    minWidth: "220px",
    maxWidth: "220px",
    maxHeight: "220px",
  },
  legend = true,
  legendTemplate = (data) => <SquareRoundedColorListLegend data={data} />,
  legendConfig = {
    verticalAlign: "bottom",
    align: "center",
    layout: "vertical",
  },
  width = 220,
  height = 220,
  showEmptyMessage = false,
  emptyMessageConfig = CLIENT_REPORT_EMPTY_CHART_MESSAGE,
  middleLabel,
  middleLabelValue,
  middleLabelConfig = {
    className: "text-5xl font-bold clr-text font-cairo",
  },
  startAngle = -270,
  sizeMode,
}) => {
  chartContainerConfig = {
    ...chartContainerConfig,
    className: `${chartContainerConfig.className} ${sizeMode}`,
  }
  return (
    <PieChartCompound
      data={data}
      className={className}
      chartContainerConfig={chartContainerConfig}
      label={false}
      responsiveContainerConfig={responsiveContainerConfig}
      legend={legend}
      legendTemplate={legendTemplate}
      legendConfig={legendConfig}
      width={width}
      height={height}
      showEmptyMessage={showEmptyMessage}
      emptyMessageConfig={emptyMessageConfig}
      middleLabel={middleLabel}
      middleLabelConfig={{
        value: middleLabelValue,
        ...middleLabelConfig,
      }}
      startAngle={startAngle}
      loading={loading}
    />
  )
}

export default GeneralSprintPointProgressChart
